import { QuoteState } from '@/experiences/sales-portal/domain/pricing/screens/quotes/blocs/hooks/use-quote-state-types';
import { toQuoteLineItem } from '@/experiences/sales-portal/domain/pricing/screens/quotes/blocs/transformers/quote-line-item-transformer';
import { useCallback } from 'react';
import { useGeneratedPriceQuotesSavedDetailLazyQuery } from '@/experiences/sales-portal/domain/pricing/screens/quotes/blocs/documents/price-quotes-saved-detail.generated';

/**
 * Returns a function that fetches a saved quote by id and shapes the
 * response into a `QuoteState` ready for `LOAD_QUOTE`.
 */
export const useLoadSavedQuote = () => {
  const fetchDetail = useGeneratedPriceQuotesSavedDetailLazyQuery();

  return useCallback(
    async (priceQuoteId: string): Promise<QuoteState | null> => {
      const { data } = await fetchDetail({
        variables: { priceQuoteId },
      });
      if (!data) {
        return null;
      }
      const detail = data.getPriceQuote;
      return {
        account: {
          chatId: detail.chat_id,
          currencyCode: detail.currency_code,
          name: detail.account_name,
        },
        competitorName: detail.competitor_name ?? null,
        isDirty: false,
        lineItems: detail.line_items.map(toQuoteLineItem),
        name: detail.name,
        quoteId: detail.price_quote_id,
      };
    },
    [fetchDetail],
  );
};
